'use client';

import { c as _c } from "react/compiler-runtime";
import { useCallback, useState, useEffect, useRef } from 'react';
import useEmblaCarousel from 'embla-carousel-react';
import Image from 'next/image';
import Modal from 'react-modal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faChevronRight, faXmark } from '@awesome.me/kit-94e593bf23/icons/sharp/light';
import { faChevronLeft as faChevronLeftLight, faChevronRight as faChevronRightLight } from '@awesome.me/kit-94e593bf23/icons/sharp/light';
import { faExpand } from '@awesome.me/kit-94e593bf23/icons/classic/light';
import { faHiveQuickShip } from '@awesome.me/kit-94e593bf23/icons/kit/custom';
import Tooltip from '@/app/_components/Tooltip';
import { useAppContext } from '@/app/_lib/_context';
import { decodeEntities } from '@/app/_lib/services/ClientUtil';
import Price from '@/app/_components/Price';
import addToCartAction from '@/app/_lib/actions/AddToCartAction';
import { useCart } from '@/app/_lib/hooks';
const VariantsCarousel = t0 => {
  const $ = _c(107);
  const {
    sub_product,
    initialVariants: t1
  } = t0;
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const initialVariants = t2;
  const {
    openCartModal
  } = useAppContext();
  const {
    refresh
  } = useCart();
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = [];
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  useEffect(_temp, t3);
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      loop: false,
      align: "start",
      slidesToScroll: 1,
      containScroll: "trimSnaps"
    };
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const [emblaRef, emblaApi] = useEmblaCarousel(t4);
  const variants = initialVariants;
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {};
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  const [addingToCart, setAddingToCart] = useState(t5);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [canScrollPrev, setCanScrollPrev] = useState(false);
  const [canScrollNext, setCanScrollNext] = useState(false);
  let t6;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      x: 0,
      y: 0
    };
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  const [cursorPos, setCursorPos] = useState(t6);
  const [cursorVisible, setCursorVisible] = useState(false);
  let t7;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      x: 0,
      y: 0
    };
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  const [modalCursorPos, setModalCursorPos] = useState(t7);
  const [modalCursorVisible, setModalCursorVisible] = useState(false);
  const [modalCursorSide, setModalCursorSide] = useState("right");
  const modalImageContainerRef = useRef(null);
  const selectedItem = variants[selectedIndex] || null;
  let t8;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = e => {
      setCursorPos({
        x: e.clientX,
        y: e.clientY
      });
    };
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  const handleImageMouseMove = t8;
  let t9;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = () => {
      setCursorVisible(true);
    };
    $[8] = t9;
  } else {
    t9 = $[8];
  }
  const handleImageMouseEnter = t9;
  let t10;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = () => {
      setCursorVisible(false);
    };
    $[9] = t10;
  } else {
    t10 = $[9];
  }
  const handleImageMouseLeave = t10;
  let t11;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = e_0 => {
      if (!modalImageContainerRef.current) {
        return;
      }
      const rect = modalImageContainerRef.current.getBoundingClientRect();
      const x = e_0.clientX - rect.left;
      setModalCursorPos({
        x: e_0.clientX,
        y: e_0.clientY
      });
      setModalCursorSide(x < rect.width / 2 ? "left" : "right");
    };
    $[10] = t11;
  } else {
    t11 = $[10];
  }
  const handleModalImageMouseMove = t11;
  let t12;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = () => {
      setModalCursorVisible(true);
    };
    $[11] = t12;
  } else {
    t12 = $[11];
  }
  const handleModalImageMouseEnter = t12;
  let t13;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = () => {
      setModalCursorVisible(false);
    };
    $[12] = t13;
  } else {
    t13 = $[12];
  }
  const handleModalImageMouseLeave = t13;
  let t14;
  if ($[13] !== modalCursorSide || $[14] !== variants.length) {
    t14 = () => {
      if (variants.length <= 1) {
        return;
      }
      if (modalCursorSide === "left") {
        setSelectedIndex(prev => prev === 0 ? variants.length - 1 : prev - 1);
      } else {
        setSelectedIndex(prev_0 => prev_0 === variants.length - 1 ? 0 : prev_0 + 1);
      }
    };
    $[13] = modalCursorSide;
    $[14] = variants.length;
    $[15] = t14;
  } else {
    t14 = $[15];
  }
  const handleModalImageClick = t14;
  let t15;
  if ($[16] !== variants) {
    t15 = item => {
      setCursorVisible(false);
      const index = variants.findIndex(v => v.id === item.id);
      setSelectedIndex(index >= 0 ? index : 0);
      setIsModalOpen(true);
    };
    $[16] = variants;
    $[17] = t15;
  } else {
    t15 = $[17];
  }
  const openItemModal = t15;
  let t16;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = () => {
      setIsModalOpen(false);
      setModalCursorVisible(false);
    };
    $[18] = t16;
  } else {
    t16 = $[18];
  }
  const closeModal = t16;
  let t17;
  let t18;
  if ($[19] !== isModalOpen || $[20] !== variants.length) {
    t17 = () => {
      if (!isModalOpen || variants.length <= 1) {
        return;
      }
      const handleKeyDown = e_1 => {
        if (e_1.key === "ArrowLeft") {
          setSelectedIndex(prev_1 => prev_1 === 0 ? variants.length - 1 : prev_1 - 1);
        } else {
          if (e_1.key === "ArrowRight") {
            setSelectedIndex(prev_2 => prev_2 === variants.length - 1 ? 0 : prev_2 + 1);
          }
        }
      };
      window.addEventListener("keydown", handleKeyDown);
      return () => window.removeEventListener("keydown", handleKeyDown);
    };
    t18 = [isModalOpen, variants.length];
    $[19] = isModalOpen;
    $[20] = variants.length;
    $[21] = t17;
    $[22] = t18;
  } else {
    t17 = $[21];
    t18 = $[22];
  }
  useEffect(t17, t18);
  let t19;
  if ($[23] !== emblaApi) {
    t19 = () => {
      if (emblaApi) {
        emblaApi.scrollPrev();
      }
    };
    $[23] = emblaApi;
    $[24] = t19;
  } else {
    t19 = $[24];
  }
  const scrollPrev = t19;
  let t20;
  if ($[25] !== emblaApi) {
    t20 = () => {
      if (emblaApi) {
        emblaApi.scrollNext();
      }
    };
    $[25] = emblaApi;
    $[26] = t20;
  } else {
    t20 = $[26];
  }
  const scrollNext = t20;
  let t21;
  if ($[27] !== emblaApi) {
    t21 = () => {
      if (!emblaApi) {
        return;
      }
      setCanScrollPrev(emblaApi.canScrollPrev());
      setCanScrollNext(emblaApi.canScrollNext());
    };
    $[27] = emblaApi;
    $[28] = t21;
  } else {
    t21 = $[28];
  }
  const updateScrollButtons = t21;
  let t22;
  let t23;
  if ($[29] !== emblaApi || $[30] !== updateScrollButtons) {
    t22 = () => {
      if (!emblaApi) {
        return;
      }
      updateScrollButtons();
      emblaApi.on("select", updateScrollButtons);
      emblaApi.on("reInit", updateScrollButtons);
      return () => {
        emblaApi.off("select", updateScrollButtons);
        emblaApi.off("reInit", updateScrollButtons);
      };
    };
    t23 = [emblaApi, updateScrollButtons];
    $[29] = emblaApi;
    $[30] = updateScrollButtons;
    $[31] = t22;
    $[32] = t23;
  } else {
    t22 = $[31];
    t23 = $[32];
  }
  useEffect(t22, t23);
  let t24;
  if ($[33] !== sub_product) {
    t24 = item_0 => {
      if (item_0.image_url) {
        return item_0.image_url;
      }
      if (item_0.swatches && item_0.swatches.length > 0) {
        const firstSwatch = item_0.swatches[0];
        if (firstSwatch.swatch_thumb) {
          return `swatch_photos/${firstSwatch.swatch_thumb}`;
        }
        if (firstSwatch.swatch_photo) {
          return `swatch_photos/${firstSwatch.swatch_photo}`;
        }
      }
      if (sub_product.thumb_1) {
        return `thumbs/${sub_product.thumb_1}`;
      }
      if (sub_product.product_photo) {
        return sub_product.product_photo;
      }
      return null;
    };
    $[33] = sub_product;
    $[34] = t24;
  } else {
    t24 = $[34];
  }
  const getImageUrl = t24;
  let t25;
  if ($[35] !== openCartModal || $[36] !== refresh || $[37] !== sub_product) {
    t25 = async item_1 => {
      setAddingToCart(prev_3 => ({
        ...prev_3,
        [item_1.id]: true
      }));
      const optionsObject = {};
      if (item_1.options && Array.isArray(item_1.options)) {
        item_1.options.forEach(option => {
          optionsObject[option.selection_id] = {
            selection_id: option.selection_id,
            option_id: option.option_id,
            option_name: option.option_name,
            selection_label: option.selection_label,
            option_price: option.option_price,
            option_photo: option.option_photo
          };
        });
      }
      const swatchesObject = {};
      if (item_1.swatches && Array.isArray(item_1.swatches)) {
        item_1.swatches.forEach(swatch => {
          swatchesObject[swatch.swatch_set_id] = {
            swatch_index: swatch.swatch_index,
            swatch_id: swatch.swatch_id,
            swatch_set_id: swatch.swatch_set_id,
            swatch_line_id: swatch.swatch_line_id,
            swatch_name: swatch.swatch_name,
            swatch_price: swatch.swatch_price,
            swatch_photo: swatch.swatch_photo,
            swatch_set_label: swatch.swatch_set_label,
            xref_id: swatch.xref_id
          };
        });
      }
      const variant = item_1.image_url ? {
        file_name: item_1.image_url,
        description: item_1.variant_description,
        sku: item_1.sku
      } : null;
      const cartObject = {
        quantity: 1,
        product: {
          sub_product_id: item_1.sub_product_id,
          options: optionsObject,
          swatches: swatchesObject,
          ...(variant && {
            variant
          })
        }
      };
      const response = await addToCartAction(cartObject);
      if (response.success) {
        refresh(response.cart);
        openCartModal({
          message: "The item was added to your cart.",
          sub_product
        });
      } else {
        console.error("Failed to add item to cart");
      }
      setAddingToCart(prev_4 => ({
        ...prev_4,
        [item_1.id]: false
      }));
    };
    $[35] = openCartModal;
    $[36] = refresh;
    $[37] = sub_product;
    $[38] = t25;
  } else {
    t25 = $[38];
  }
  const handleAddToCart = t25;
  if (variants.length === 0) {
    return null;
  }
  let t26;
  if ($[39] !== sub_product.sub_product_name) {
    t26 = decodeEntities(sub_product.sub_product_name);
    $[39] = sub_product.sub_product_name;
    $[40] = t26;
  } else {
    t26 = $[40];
  }
  let t27;
  if ($[41] !== t26 || $[42] !== variants.length) {
    t27 = <h2 className="leading-[1] text-2xl font-extralight capitalize">{t26} Options ({variants.length})</h2>;
    $[41] = t26;
    $[42] = variants.length;
    $[43] = t27;
  } else {
    t27 = $[43];
  }
  let t28;
  if ($[44] === Symbol.for("react.memo_cache_sentinel")) {
    t28 = <p className="text-xs text-light-3 m-0">Pre-configured variants of this product</p>;
    $[44] = t28;
  } else {
    t28 = $[44];
  }
  let t29;
  if ($[45] !== t27) {
    t29 = <div className="mb-3">{t27}{t28}</div>;
    $[45] = t27;
    $[46] = t29;
  } else {
    t29 = $[46];
  }
  let t30;
  if ($[47] !== canScrollNext || $[48] !== canScrollPrev || $[49] !== scrollPrev) {
    t30 = (canScrollPrev || canScrollNext) && <button onClick={scrollPrev} disabled={!canScrollPrev} aria-label="Previous items" className={`absolute left-[calc(var(--site-padding)+0.75rem)] top-1/3 z-100 shrink-0 mr-2 ${canScrollPrev ? "cursor-pointer" : "cursor-default opacity-30"}`}><div className="w-10 h-10 rounded-full bg-white shadow-lg flex items-center justify-center hover:shadow-lg transition-shadow"><FontAwesomeIcon icon={faChevronLeft} className="text-dark text-sm" /></div></button>;
    $[47] = canScrollNext;
    $[48] = canScrollPrev;
    $[49] = scrollPrev;
    $[50] = t30;
  } else {
    t30 = $[50];
  }
  let t31;
  if ($[51] !== addingToCart || $[52] !== getImageUrl || $[53] !== handleAddToCart || $[54] !== openItemModal || $[55] !== sub_product.retail_price || $[56] !== sub_product.sub_product_name || $[57] !== variants) {
    let t32;
    if ($[59] !== addingToCart || $[60] !== getImageUrl || $[61] !== handleAddToCart || $[62] !== openItemModal || $[63] !== sub_product.retail_price || $[64] !== sub_product.sub_product_name || $[65] !== variants.length) {
      t32 = (item_2, index_0) => <div key={item_2.id || index_0} className={`flex-none pr-3 ${variants.length <= 5 ? "w-1/2 sm:w-1/3 md:w-1/4 xl:w-1/5 2xl:w-[16.666%]" : "w-1/2 sm:w-1/3 md:w-1/4 lg:w-1/5 xl:w-1/6 2xl:w-[14.285%]"}`}><div className="group h-full flex flex-col"><div className="relative w-full aspect-square mb-3 flex items-center justify-center cursor-none bg-gray-3 overflow-hidden" onClick={() => openItemModal(item_2)} onMouseMove={handleImageMouseMove} onMouseEnter={handleImageMouseEnter} onMouseLeave={handleImageMouseLeave}>{getImageUrl(item_2) && <div className="overlay-block lg:transition-all lg:duration-400 lg:group-hover:scale-105"><Image src={`${process.env.NEXT_PUBLIC_RESOURCE_URL}/${getImageUrl(item_2)}`} alt={item_2.variant_description || decodeEntities(item_2.sub_product_name)} width={120} height={120} sizes="120px" className="max-w-[120px] max-h-[120px] object-contain pointer-events-none" /></div>}</div><div className="text-left flex-1 flex flex-col">{item_2.on_sale == 1 && item_2.discount_percentage > 0 && <div className="text-2xs mb-3 text-red"><span className="font-semibold">Sale</span> {item_2.discount_percentage}% off</div>}<div className="font-medium text-sm capitalize mb-2">{decodeEntities(sub_product.sub_product_name)}</div>{item_2.options?.length > 0 && <div className="mb-1 text-2xs">{item_2.options.map(_temp2)}</div>}{item_2.swatches?.length > 0 && <div className="mb-1 text-2xs">{item_2.swatches.map(_temp3)}</div>}<div className="text-xs mt-1 mb-4"><Price amount={item_2.retail_price || sub_product.retail_price} />{item_2.on_sale == 1 && parseFloat(item_2.original_price) > 0 && <span className="line-through text-light ml-1"><Price amount={item_2.original_price} /></span>}{(item_2.quick_ship_quantity > 0 || item_2.inventory_quantity > 0) && <Tooltip content="This variant is in stock and ready to ship!" side="top"><span><FontAwesomeIcon icon={faHiveQuickShip} className="ml-1 text-base text-primary cursor-pointer" /></span></Tooltip>}</div><div className="flex-1" /><button onClick={() => handleAddToCart(item_2)} disabled={addingToCart[item_2.id]} className="btn btn-xs btn-extra-light w-full">{addingToCart[item_2.id] ? "Adding..." : "Add to Cart"}</button></div></div></div>;
      $[59] = addingToCart;
      $[60] = getImageUrl;
      $[61] = handleAddToCart;
      $[62] = openItemModal;
      $[63] = sub_product.retail_price;
      $[64] = sub_product.sub_product_name;
      $[65] = variants.length;
      $[66] = t32;
    } else {
      t32 = $[66];
    }
    t31 = variants.map(t32);
    $[51] = addingToCart;
    $[52] = getImageUrl;
    $[53] = handleAddToCart;
    $[54] = openItemModal;
    $[55] = sub_product.retail_price;
    $[56] = sub_product.sub_product_name;
    $[57] = variants;
    $[58] = t31;
  } else {
    t31 = $[58];
  }
  let t32;
  if ($[67] !== t31) {
    t32 = <div className="flex">{t31}</div>;
    $[67] = t31;
    $[68] = t32;
  } else {
    t32 = $[68];
  }
  let t33;
  if ($[69] !== emblaRef || $[70] !== t32) {
    t33 = <div className="flex-1 min-w-0"><div ref={emblaRef} className="overflow-hidden">{t32}</div></div>;
    $[69] = emblaRef;
    $[70] = t32;
    $[71] = t33;
  } else {
    t33 = $[71];
  }
  let t34;
  if ($[72] !== canScrollNext || $[73] !== canScrollPrev || $[74] !== scrollNext) {
    t34 = (canScrollPrev || canScrollNext) && <button onClick={scrollNext} disabled={!canScrollNext} aria-label="Next items" className={`absolute right-[calc(var(--site-padding)+0.75rem)] top-1/3 shrink-0 ml-2 ${canScrollNext ? "cursor-pointer" : "cursor-default opacity-30"}`}><div className="w-10 h-10 rounded-full bg-white shadow-md flex items-center justify-center hover:shadow-lg transition-shadow"><FontAwesomeIcon icon={faChevronRight} className="text-dark text-sm" /></div></button>;
    $[72] = canScrollNext;
    $[73] = canScrollPrev;
    $[74] = scrollNext;
    $[75] = t34;
  } else {
    t34 = $[75];
  }
  let t35;
  if ($[76] !== t30 || $[77] !== t33 || $[78] !== t34) {
    t35 = <div className="flex items-center -mr-3">{t30}{t33}{t34}</div>;
    $[76] = t30;
    $[77] = t33;
    $[78] = t34;
    $[79] = t35;
  } else {
    t35 = $[79];
  }
  let t36;
  if ($[80] !== cursorPos || $[81] !== cursorVisible) {
    t36 = cursorVisible && <div className="pointer-events-none fixed z-[100] flex items-center justify-center w-10 h-10 rounded-full bg-white shadow-md" style={{
      left: cursorPos.x,
      top: cursorPos.y,
      transform: "translate(-50%, -50%)"
    }}><FontAwesomeIcon icon={faExpand} className="text-sm text-dark" /></div>;
    $[80] = cursorPos;
    $[81] = cursorVisible;
    $[82] = t36;
  } else {
    t36 = $[82];
  }
  let t37;
  if ($[83] !== addingToCart || $[84] !== getImageUrl || $[85] !== handleAddToCart || $[86] !== handleModalImageClick || $[87] !== selectedIndex || $[88] !== selectedItem || $[89] !== sub_product.retail_price || $[90] !== sub_product.sub_product_name || $[91] !== variants.length) {
    t37 = selectedItem && <div className="p-5"><button onClick={closeModal} className="absolute top-3 right-3 z-10 w-8 h-8 flex items-center justify-center bg-white/80 rounded-full hover:bg-white transition-colors" aria-label="Close"><FontAwesomeIcon icon={faXmark} className="text-lg" /></button><div ref={modalImageContainerRef} className={`p-3 relative select-none flex items-center justify-center ${variants.length > 1 ? "lg:cursor-none" : ""}`} style={{
        height: "min(50vh, 400px)"
      }} onMouseMove={handleModalImageMouseMove} onMouseEnter={handleModalImageMouseEnter} onMouseLeave={handleModalImageMouseLeave} onClick={handleModalImageClick}><div className="overlay-block h-full w-full flex items-center justify-center relative p-4">{getImageUrl(selectedItem) && <Image src={`${process.env.NEXT_PUBLIC_RESOURCE_URL}/${getImageUrl(selectedItem)}`} alt={selectedItem.variant_description || decodeEntities(selectedItem.sub_product_name)} quality={90} width={400} height={400} sizes="400px" className="max-w-full max-h-full object-contain pointer-events-none" />}{variants.length > 1 && <><button onClick={e_2 => {
              e_2.stopPropagation();
              setSelectedIndex(prev_5 => prev_5 === 0 ? variants.length - 1 : prev_5 - 1);
            }} className="lg:hidden absolute left-2 top-1/2 -translate-y-1/2 w-10 h-10 rounded-full bg-white/80 flex items-center justify-center z-20" aria-label="Previous variant"><FontAwesomeIcon icon={faChevronLeft} className="text-dark text-sm" /></button><button onClick={e_3 => {
              e_3.stopPropagation();
              setSelectedIndex(prev_6 => prev_6 === variants.length - 1 ? 0 : prev_6 + 1);
            }} className="lg:hidden absolute right-2 top-1/2 -translate-y-1/2 w-10 h-10 rounded-full bg-white/80 flex items-center justify-center z-20" aria-label="Next variant"><FontAwesomeIcon icon={faChevronRight} className="text-dark text-sm" /></button></>}</div></div>{variants.length > 1 && <div className="text-right text-xs text-light mt-1 pr-3">{selectedIndex + 1} / {variants.length}</div>}<div className="mt-4">{selectedItem.on_sale == 1 && selectedItem.discount_percentage > 0 && <div className="text-2xs mb-3 text-red"><span className="font-semibold">Sale</span> {selectedItem.discount_percentage}% off</div>}<div className="font-medium text-base capitalize">{decodeEntities(sub_product.sub_product_name)}</div>{selectedItem.options?.length > 0 && <div className="mt-2 text-sm">{selectedItem.options.map(_temp4)}</div>}{selectedItem.swatches?.length > 0 && <div className="mt-2 text-sm">{selectedItem.swatches.map(_temp5)}</div>}<div className="text-sm mt-2 mb-4"><Price amount={selectedItem.retail_price || sub_product.retail_price} />{selectedItem.on_sale == 1 && parseFloat(selectedItem.original_price) > 0 && <span className="line-through text-light ml-2"><Price amount={selectedItem.original_price} /></span>}{(selectedItem.quick_ship_quantity > 0 || selectedItem.inventory_quantity > 0) && <Tooltip content="This variant is in stock and ready to ship!" side="top"><span><FontAwesomeIcon icon={faHiveQuickShip} className="ml-1 text-base text-primary" /></span></Tooltip>}</div><button onClick={() => {
          handleAddToCart(selectedItem);
          closeModal();
        }} disabled={addingToCart[selectedItem.id]} className="btn btn-sm btn-extra-light w-full">{addingToCart[selectedItem.id] ? "Adding..." : "Add to Cart"}</button></div></div>;
    $[83] = addingToCart;
    $[84] = getImageUrl;
    $[85] = handleAddToCart;
    $[86] = handleModalImageClick;
    $[87] = selectedIndex;
    $[88] = selectedItem;
    $[89] = sub_product.retail_price;
    $[90] = sub_product.sub_product_name;
    $[91] = variants.length;
    $[92] = t37;
  } else {
    t37 = $[92];
  }
  let t38;
  if ($[93] !== isModalOpen || $[94] !== t37) {
    t38 = <Modal isOpen={isModalOpen} onRequestClose={closeModal} contentLabel="Product Variant" overlayClassName="fixed inset-0 z-[1000] flex items-center justify-center bg-modal-overlay p-6" className="relative bg-white rounded-lg w-full max-w-[500px] outline-none" bodyOpenClassName="ReactModal__Body--open" htmlOpenClassName="ReactModal__Html--open">{t37}</Modal>;
    $[93] = isModalOpen;
    $[94] = t37;
    $[95] = t38;
  } else {
    t38 = $[95];
  }
  let t39;
  if ($[96] !== modalCursorPos || $[97] !== modalCursorSide || $[98] !== modalCursorVisible || $[99] !== variants.length) {
    t39 = modalCursorVisible && variants.length > 1 && <div className="pointer-events-none fixed z-[1100] flex items-center justify-center w-12 h-12 rounded-full bg-white shadow-md" style={{
      left: modalCursorPos.x,
      top: modalCursorPos.y,
      transform: "translate(-50%, -50%)"
    }}><FontAwesomeIcon icon={modalCursorSide === "left" ? faChevronLeftLight : faChevronRightLight} className="text-xl text-dark" /></div>;
    $[96] = modalCursorPos;
    $[97] = modalCursorSide;
    $[98] = modalCursorVisible;
    $[99] = variants.length;
    $[100] = t39;
  } else {
    t39 = $[100];
  }
  let t40;
  if ($[101] !== t29 || $[102] !== t35 || $[103] !== t36 || $[104] !== t38 || $[105] !== t39) {
    t40 = <div className="site-padding mb-10 lg:mb-8 w-full min-[1810px]:px-0 relative">{t29}{t35}{t36}{t38}{t39}</div>;
    $[101] = t29;
    $[102] = t35;
    $[103] = t36;
    $[104] = t38;
    $[105] = t39;
    $[106] = t40;
  } else {
    t40 = $[106];
  }
  return t40;
};
export default VariantsCarousel;
function _temp() {
  Modal.setAppElement("#hivenext");
}
function _temp2(option_0, idx) {
  return <div key={idx}><span className="text-light capitalize">{option_0.selection_label}:</span> <span className="text-dark">{option_0.option_name}</span></div>;
}
function _temp3(swatch_0, idx_0) {
  return <div key={idx_0}><span className="text-light capitalize">{swatch_0.swatch_set_label}:</span> <span className="text-dark">{swatch_0.swatch_name}</span></div>;
}
function _temp4(option_1, idx_1) {
  return <div key={idx_1}><span className="text-light capitalize">{option_1.selection_label}:</span> <span className="text-dark">{option_1.option_name}</span></div>;
}
function _temp5(swatch_1, idx_2) {
  return <div key={idx_2}><span className="text-light capitalize">{swatch_1.swatch_set_label}:</span> <span className="text-dark">{swatch_1.swatch_name}</span></div>;
}